<template>
  <b-form-group class="multi-select-input">
    <b-form-text v-if="fieldLimitText || description" class="text-muted text-justify mt-0 mb-3">
      {{ fieldLimitText }} {{ description }}
    </b-form-text>
    <div class="row" v-for="(chunk, i) in chunkOptions(options, getColumnsNumber(fieldColumns))" :key="i">
      <div v-bind:key="index" v-for="index in getColumnsNumber(fieldColumns)" class="col-12" :class="[inline && 'col-lg-'+12/getColumnsNumber(fieldColumns)+' mb-2', !inline && 'mb-3']">
        <b-form-checkbox-group v-if="chunk[index-1]"
                               v-model="selectedOptions"
                               :name="fieldKey"
                               size="lg"
                               :disabled="disabled"
                               @change="validateOnTick">
          <b-form-checkbox :value="chunk[index-1][valueKey] || chunk[index-1]">
            {{ chunk[index-1][textKey] || chunk[index-1] }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import {chunkArray} from "@/utils/ChunkArray";
import get from "lodash.get";

export default {
  name: "MultiSelectInput",
  props: {
    disabled: Boolean,
    fieldKey: String,
    fieldColumns: Number,
    valueKey: String,
    textKey: String,
    description: String,
    value: Array,
    options: [Array, Object],
    limits: Object,
    invalidOnEmpty: {
      type: Boolean,
      default: false,
    },
    validOnEmpty: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedOptions: [],
      state: null,
    }
  },
  mounted() {
    if (!this.value) {
      this.$emit('input', []);
    }

    if (this.value) {
      this.selectedOptions = JSON.parse(JSON.stringify(this.value));
    }
  },
  methods: {
    chunkOptions(options, chunkSize = 3) {
      return chunkArray(options, chunkSize);
    },
    getColumnsNumber(fieldColumns) {
      if (fieldColumns > 0) {
        return fieldColumns;
      }
      return 3;
    },
    validateOnTick() {
      this.$nextTick(() => {
        this.validate()
      })
    },
    validate() {
      const limitsFrom = parseInt(get(this.limits, 'from'));
      const limitsTo = parseInt(get(this.limits, 'to'));

      setTimeout(() => {
        if (this.value === undefined) {
          this.$emit('input', []);
        }
      }, 0);

      setTimeout(() => {
        if (this.validOnEmpty && !this.value.length) {
          this.$emit('valid');
          this.state = null;
        } else if (limitsFrom && limitsFrom > 0 && this.value.length < limitsFrom) {
          this.$emit('invalid');
          this.state = false
        } else if (limitsTo && limitsTo > 0 && this.value.length > limitsTo) {
          this.$emit('invalid');
          this.state = false
        } else if (this.invalidOnEmpty && !this.value.length) {
          this.$emit('invalid');
          this.state = false
        } else {
          this.$emit('valid');
          this.state = null;
        }
      }, 0)
    }
  },
  computed: {
    fieldLimitText() {
      const limitsFrom = parseInt(get(this.limits, 'from'));
      const limitsTo = parseInt(get(this.limits, 'to'));

      if (limitsFrom && !limitsTo) {
        return `Wybierz przynajmniej ${limitsFrom} odpowiedzi.`
      }

      if (limitsFrom && limitsTo) {
        return `Wybierz od ${limitsFrom} do ${limitsTo}  odpowiedzi.`
      }

      if (!limitsFrom && limitsTo) {
        return limitsTo === 1
            ? `Wybierz maksymalnie jedną odpowiedź.`
            : `Wybierz do ${limitsTo} odpowiedzi.`;
      }

      return null;
    }
  },
  watch: {
    value(newVal) {
      this.selectedOptions = newVal
    },
    selectedOptions(newVal) {
      this.$emit('input', newVal);
    },
    state(newVal) {
      if (newVal === false) {
        this.$emit('invalid');
      } else {
        this.$emit('valid');
      }
    }
  }
}
</script>

<style scoped>

.multi-select-input >>> .custom-checkbox .custom-control-label::before {
  border-color: #adb5bd !important;
}

.multi-select-input >>> .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: var(--accent-color) !important;
}

.multi-select-input >>> .custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {
  background: #f4f5f8 !important;
}

</style>
